import { AUTH_ERROR_CODES, AUTH_ERROR_NAMES } from '../constants';

export const getErrorMessage = (error, variant) => {
	const unknownError = `${variant} ${AUTH_ERROR_NAMES[AUTH_ERROR_CODES.ERROR]}`;

	if (error && error.extensions) {
		const errorData = error.extensions;
		const code = errorData.authError;

		if (code === AUTH_ERROR_CODES.USERS_ARE_NOT_ALLOWED_TO_LOG_IN) {
			return errorData.roleName + AUTH_ERROR_NAMES[code];
		}
		return code ? AUTH_ERROR_NAMES[code] : unknownError;
	}
	else { return unknownError; }
};


